import { color } from "./constants"

const primaryBackground = {
    backgroundColor: color.primary
}

const primaryBorder = {
    borderColor: color.primary
}

const primaryColor = {
    color: color.primary
}

const secondaryBackground = {
    backgroundColor: color.secondary
}

const defaultInputColor = {
    color: color.defaultInputColor
}

const secondaryBorder = {
    borderColor: color.secondary
}

const secondaryColor = {
    color: color.secondary
}

const defaultBoarder = {
    color: color.defaultBoarderColor
}

const inputborderColor = {
    borderColor: color.inputborderColor
}

const radioBgColor = {
    background: color.radioColor
}
const radioBorderColor = {
    borderColor: color.radioColor
}

export const baseCss = { primaryBackground, primaryBorder, defaultBoarder, secondaryBackground, secondaryBorder, primaryColor, secondaryColor, inputborderColor, defaultInputColor, radioBgColor, radioBorderColor }